module.exports = __webpack_public_path__ + "static/media/globe.3434913a.svg";